import { Department } from "./user";

export const QuestionStatusArray = [
  "pending",
  "in_progress",
  "answered",
] as const;
export type QuestionStatus = (typeof QuestionStatusArray)[number];

export const QuestionTypeArray = [
  "question",
  "enhancement",
  "suggestion",
  "compliment",
] as const;
export type QuestionType = (typeof QuestionTypeArray)[number];

export type Question = {
  id: number;
  title: string;
  content: string;
  student: number;
  user_name: string;
  email: string;
  phone: string;
  answer: number | null;
  status: QuestionStatus;
  type: QuestionType;
  department: Department[];
  created_at: string;
};
